import React, { useEffect, useState } from "react";
import { MenuForListType, MenuNameList } from "./MenuNameList";
import { useMenuListGet } from "./menuListClient";
import { Button } from "../design-system/Button";
import { VerticalScrolls } from "../design-system/Container";
import { Link } from "react-router-dom";
import { Box, Divider, Paper, Typography } from "@mui/material";
import { AddBox, RocketLaunch } from "@mui/icons-material";

const FirstMenuPrompt = () => (
  <Paper
    elevation={0}
    sx={{
      border: "2px dashed",
      borderColor: "primary.light",
      borderRadius: 3,
      p: 4,
      textAlign: "center",
      bgcolor: "rgba(25, 118, 210, 0.03)",
    }}
  >
    <RocketLaunch
      color="primary"
      sx={{ fontSize: 48, mb: 1.5, opacity: 0.7 }}
    />
    <Typography variant="h6" fontWeight={600} gutterBottom>
      Ready to go live?
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
      Create your first digital menu, set up table QR codes, and start taking
      orders — in minutes.
    </Typography>
    <Button
      component={Link}
      to="/dashboard/create-menu"
      variant="contained"
      size="large"
      startIcon={<AddBox />}
    >
      Create your first menu
    </Button>
  </Paper>
);

export const UserMenuList = () => {
  const { menuList } = useMenuListGet();
  const [menus, setMenus] = useState<MenuForListType[] | undefined>();

  const hasNoMenus = menus?.length === 0;

  useEffect(() => {
    setMenus(menuList);
  }, [menuList]);

  return (
    <VerticalScrolls height="calc(100vh - (50px));">
      <Box maxWidth={720} mx="auto" px={3} pt={4} pb={6}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={3}
        >
          <Typography variant="h5" fontWeight={700}>
            My Menus
          </Typography>
          {!hasNoMenus && (
            <Button
              component={Link}
              to="/dashboard/create-menu"
              startIcon={<AddBox />}
              size="small"
            >
              New menu
            </Button>
          )}
        </Box>

        {hasNoMenus ? (
          <FirstMenuPrompt />
        ) : (
          <Paper
            variant="outlined"
            sx={{ borderRadius: 2, overflow: "hidden" }}
          >
            <MenuNameList menus={menus} />
          </Paper>
        )}
      </Box>
    </VerticalScrolls>
  );
};
